import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../components/helper";

export const userLogin = createAsyncThunk("users/login", async (payload) => {
  const response = await http.post("login", payload);
  return response.data;
});

export const forgotpass = createAsyncThunk(
  "users/forgotpass",
  async (payload) => {
    const response = await http.post("forgotpassword", payload);
    return response.data;
  }
);
export const createpass = createAsyncThunk(
  "users/createpass",
  async (payload) => {
    const response = await http.post("createpassword", payload);
    return response.data;
  }
);

export const passwordtoken = createAsyncThunk(
  "users/passwordtoken",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await http.post("passwordtokencheck", payload);
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(error.response.data);
      }
    }
  }
);

export const passwordreset = createAsyncThunk(
  "users/passwordreset",
  async (payload) => {
    const response = await http.post("resetpassword", payload);
    return response.data;
  }
);

export const unsubscribe = createAsyncThunk(
  "users/unsubscribe",
  async (payload) => {
    const response = await http.post("unsubscribe", payload);
    return response.data;
  }
);

export const userActive = createAsyncThunk(
  "users/isactive",
  async (payload) => {
    const response = await http.post("isactive", payload);
    return response.data;
  }
);

export const switchsubAccount = createAsyncThunk(
  "users/switchsubAccount",
  async (payload) => {
    const response = await http.post("switchsubAccount", payload);
    return response.data;
  }
);


const initialState = {
  userData: [],
  forgotpassData: [],
  createPassData:[],
  passtoken: [],
  resetpass: [],
  unsub:[],
  status: "idle",
  forgotStatus: "idle",
  createStatus: "idle",
  error: null,
  passtokenstatus: "idle",
  passtokenerror: null,
  resetpassStatus: "idle",
  resetpassError: null,
  unsubStatus: "idle",
  unsubError: null,
  userActive: [],
  activeStatus: "idle",
  activeError: null,
  subaccountUser: [],
  subaccountStatus: "idle",
  subaccountError: null,

};

const usersSlice = createSlice({
  name: "Users",
  initialState,
  reducers: {
    logout(state) {
      state.userData = [];
      state.status = "idle";
      state.error = null;
    },
    resetUserdetails(state) {
      state.userActive = [];
      state.activeStatus = "idle";
      state.activeError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.userData = action.payload;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(forgotpass.pending, (state) => {
        state.forgotStatus = "loading";
        state.error = null;
      })
      .addCase(forgotpass.fulfilled, (state, action) => {
        state.forgotStatus = "succeeded";
        state.forgotpassData = action.payload;
        state.error = null;
      })
      .addCase(forgotpass.rejected, (state, action) => {
        state.forgotStatus = "failed";
        state.error = action.error.message;
      })
       .addCase(createpass.pending, (state) => {
        state.createStatus = "loading";
        state.error = null;
      })
      .addCase(createpass.fulfilled, (state, action) => {
        state.createStatus = "succeeded";
        state.createPassData = action.payload;
        state.error = null;
      })
      .addCase(createpass.rejected, (state, action) => {
        state.createStatus = "failed";
        state.error = action.error.message;
      })
      .addCase(passwordtoken.pending, (state) => {
        state.passtokenstatus = "loading";
      })
      .addCase(passwordtoken.fulfilled, (state, action) => {
        state.passtokenstatus = "succeeded";
        state.passtoken = action.payload;
      })
      .addCase(passwordtoken.rejected, (state, action) => {
        state.passtokenstatus = "failed";
        state.passtokenerror = action.payload;
      })
      .addCase(passwordreset.pending, (state) => {
        state.resetpassStatus = "loading";
      })
      .addCase(passwordreset.fulfilled, (state, action) => {
        state.resetpassStatus = "succeeded";
        state.resetpass = action.payload;
      })
      .addCase(passwordreset.rejected, (state, action) => {
        state.resetpassStatus = "failed";
        state.resetpassError = action.error.message;
      })
      .addCase(unsubscribe.pending, (state) => {
        state.unsubStatus = "loading";
      })
      .addCase(unsubscribe.fulfilled, (state, action) => {
        state.unsubStatus = "succeeded";
        state.unsub = action.payload;
      })
      .addCase(unsubscribe.rejected, (state, action) => {
        state.unsubStatus = "failed";
        state.unsubError = action.payload;
      })
      .addCase(userActive.pending, (state) => {
        state.activeStatus = "loading";
      })
      .addCase(userActive.rejected, (state, action) => {
        state.activeStatus = "failed";
        state.activeError = action.error.message;
      })
      .addCase(userActive.fulfilled, (state, action) => {
        state.activeStatus = "succeeded";
        state.userActive = action.payload;
      })
      .addCase(switchsubAccount.pending, (state) => {
        state.subaccountStatus = "loading";
      })
      .addCase(switchsubAccount.rejected, (state, action) => {
        state.subaccountStatus = "failed";
        state.subaccountError = action.error.message;
      })
      .addCase(switchsubAccount.fulfilled, (state, action) => {
        console.log("switchsubAccount fulfilled:", action.payload); // Debug log
        state.subaccountStatus = "succeeded";
        state.subaccountUser = action.payload;
      });
  },
});

export const { logout, resetUserdetails } = usersSlice.actions;
export default usersSlice.reducer;
